<script setup lang="ts">
    import Worksite from '@/app/worksite/models/Worksite';
    import Contact from '~/app/contact/models/Contact';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    interface Props extends FormInputProps {
        filterByContact?: Contact | null;
        withCreateButton?: boolean;
        createButtonFields?: Record<string, any>;
        submenuPosition?: 'left-0' | 'right-0';
    }

    const props = defineProps<Props>();
    const inputData: FormInputData = useFormInput(props);
    const select = ref(null);
    const emit = defineEmits(['selected']);

    const selectWorksite = (worksite: Worksite | null) => {
        inputData.model.value = worksite;
        emit('selected', worksite);
    };
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectWorksite
            ref="select"
            :initial-value="inputData.model.value"
            :filter-by-contact="props.filterByContact || null"
            :submenu-position="props.submenuPosition || 'left-0'"
            :with-create-button="props.withCreateButton || false"
            :create-button-fields="props.createButtonFields || {}"
            @selected="selectWorksite"
        ></SelectWorksite>
    </FormElement>
</template>
